module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS4.a3cfb306.jpg";